var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.pageComponent,{tag:"Component",attrs:{"clients-see-more":_vm.clientsSeeMore}}),_vm._v(" "),_c('HowMuchBlock'),_vm._v(" "),_c('TryNewPlatformForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }